import { tv } from "../../variants/tv.js";
const blockquoteVariants = tv({
    slots: {
        root: 'flex gap-6',
        borderSlot: 'bg-primary-8 w-px shrink-0 self-stretch',
        contentSlot: 'flex min-h-px min-w-px flex-1 flex-col items-start',
        quoteSlot: 'text-neutral-13 text-body1 relative min-w-full shrink-0 whitespace-pre-wrap italic',
        attributionSlot: 'text-body2 text-neutral-10 relative flex w-full shrink-0 items-center gap-1',
        attributionDashSlot: 'relative shrink-0',
        attributionTextSlot: 'relative min-h-px min-w-px flex-1 shrink-0 whitespace-pre-wrap'
    },
    variants: {
        container: {
            lg: {
                contentSlot: 'gap-5',
                quoteSlot: 'max-w-[768px]'
            },
            md: {
                contentSlot: 'gap-4',
                quoteSlot: 'text-body2 max-w-[512px]'
            }
        }
    },
    defaultVariants: {
        container: 'lg'
    }
});
export { blockquoteVariants };
